<template>
  <div style="height: 650px;">
    <v-fade-transition>
      <v-row justify="center" align="center" class="fill-height">
        <v-col cols="auto">
          <fitt-cards-deck
              id="cards_deck"
              style="transition: all 0.5s;"
              :cards="selectableCards"
              :dense="selectedCards.length > 0"
              v-if="showDeck"
              @selectCard="initAnimation()"
          ></fitt-cards-deck>
        </v-col>
        <v-col cols="auto"
               :key="card.id"
               v-for="(card, index) in selectedCards"
        >
          <v-fade-transition>
            <selected-fitt-card
                style="transition: all 0.8s;"
                :id="'selected_card_' + index"
                :card="card"
                :index="index"
                v-if="card"
                @openTools="openToolSelector($event)"
            ></selected-fitt-card>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-fade-transition>
    <tool-selector
        :tools="tools"
        :selected-tools="selectedCards.map(({tool}) => tool && tool.id)"
        v-model="toolSelector"
        @select="selectTool($event)"
    ></tool-selector>
  </div>
</template>

<script>
import FittCardsDeck from "@/views/Tools/SecPeak/Components/FittCardsDeck";
import SelectedFittCard from "@/views/Tools/SecPeak/Components/SelectedFittCard";
import ToolSelector from "@/views/Tools/SecPeak/Components/ToolSelector";

export default {
  name: "PitstopProcess",
  components: {
    FittCardsDeck,
    SelectedFittCard,
    ToolSelector,
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
    tools: {
      type: Array,
      required: true,
    },
  },
  computed: {
    selectableCards() {
      return this.innerCards.filter(({selected}) => !selected);
    },
    selectedCards() {
      return this.innerCards.filter(({selected}) => selected).reverse();
    },
  },
  data: () => ({
    innerCards: [],
    toolSelector: false,
    selectedCard: null,
    showDeck: true,
  }),
  methods: {
    initCards() {
      this.innerCards = this.shuffleCards(this.cards.map((card) => {
        return {
          ...card,
          selected: false,
          tool: null,
        };
      }));
    },
    shuffleCards(cards) {
      let currentIndex = cards.length, randomIndex;

      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [cards[currentIndex], cards[randomIndex]] = [
          cards[randomIndex], cards[currentIndex]];
      }

      return cards;
    },
    openToolSelector(card) {
      this.selectedCard = card;

      this.$nextTick(() => {
        this.toolSelector = true;
      });
    },
    selectTool(tool) {
      this.selectedCard.tool = tool;

      this.$nextTick(() => {
        this.toolSelector = false;
      });
    },
    initAnimation() {
      this.moveDeck();
      this.rotateSelectedCard();
    },
    moveDeck() {
      const deck = document.getElementById('cards_deck');

      if (this.selectedCards.length === 0) {
        if (deck) {
          deck.style.position = 'absolute';
          deck.style.right = 'calc(50% - 208px)';
          setTimeout(() => {
            deck.style.right = '20px';
            deck.style.bottom = '-10px';
          }, 0);
        }
      } else if (this.selectedCards.length === 3) {
        if (deck) {
          deck.style.bottom = '-160px';
        }
      }
    },
    rotateSelectedCard() {
      setTimeout(() => {
        const card = document.getElementById(`selected_card_${this.selectedCards.length - 1}`);
        if (card) {
          setTimeout(() => {
            card.style.transform = 'rotateY(0deg)';
          }, 100);
        }
      });
    },
    reset() {
      this.showDeck = false;
      this.$nextTick(() => {
        this.showDeck = true;
        this.initCards();
      });
    },
  },
  mounted() {
    this.initCards();
  }
}
</script>

<style scoped>

</style>